import useLocalStorage, { getLocalStorageItem } from './useLocalStorage';

// Features that are off by default but can be previewed per browser, e.g. in prod by the product team.
// Toggle them in the backoffice (Feature toggles), or with `?preview=<name>` on any page and `?preview=off` for all.
export type FeaturePreview = 'latest-post' | 'post-reach' | 'collections-hub' | 'post-insights';

export const featurePreviews: { name: FeaturePreview; label: string }[] = [
  { name: 'latest-post', label: 'Latest post excerpt on company cards (featured matches, promoted, onboarding)' },
  { name: 'post-reach', label: 'Post reach on the company dashboard' },
  { name: 'collections-hub', label: 'New Collections page (companies table, list cards and suggestions)' },
  { name: 'post-insights', label: 'Posts section on the company Insights page, and impression counts on posts' },
];

const storageKey = (name: FeaturePreview) => `preview:${name}`;

function applyPreviewParam() {
  const param = new URLSearchParams(window.location.search).get('preview');
  if (!param) return;

  if (param === 'off') {
    Object.keys(window.localStorage)
      .filter(key => key.startsWith('preview:'))
      .forEach(key => window.localStorage.removeItem(key));
  } else {
    window.localStorage.setItem(storageKey(param as FeaturePreview), JSON.stringify(true));
  }
}

export default function useFeaturePreview(name: FeaturePreview): boolean {
  applyPreviewParam();
  return getLocalStorageItem(storageKey(name), false);
}

export function useFeaturePreviewSetting(name: FeaturePreview) {
  const [value, setValue] = useLocalStorage(storageKey(name), false);
  return [value ?? false, setValue] as const;
}
